import { AUTH_KEY, AUTH_PASS } from "./../constants";
import { normalizeJSON, sendEvent } from "../util/utils";
import axios from "./../handlers/axios";

export const apiRequest = async function (method, route, data, options){

    try {
        let request = null;
        let result = null;
    
        if (data && method && method === "POST") {
          data.authkey = AUTH_KEY;
          data.authPass = AUTH_PASS;
    
          request = await axios.post(route, data, options || {});
          result = request.data;
        }

        let normalizeJSON = route === "/ListarTipoExame";

        return apiErrorHandler(result, normalizeJSON);

    } catch (error) {
        console.error(`Error when trying to request API service ${route}: ${error.message}`);
        return null;
    }
}

export const apiErrorHandler = async function ( response, shouldNormalizeJSON ){
    let isPDF = response && response.byteLength;

    if(shouldNormalizeJSON){
       response = normalizeJSON(response);
    }

    if (response && (response.status || isPDF) ){
        if(response.status == "200"){
            return response;
        }
        if(isPDF){
            return response;
        }
        if(response.status == "400"){
            return null;
        }
        if(response.status == "401"){
            return logUserOut();
        }   
        if(response.status == "404"){
            return null;
        }     
      }
    console.error(`Unknown API error: ${response && response.status}`);
    return null;
}

export function logUserOut(){
    sendEvent("logUserOut");

    return null;
}